import { useState } from "react";
import { useToast } from "../../../hooks/useToast";
import SendAgainLink from "../../atoms/sendAgain/SendAgainLink";

const SendAgainFlow = ({ resendFunction, label }) => {
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);

  const handleResend = async () => {
    setLoading(true);
    try {
      await resendFunction();
    } catch (err) {
      showToast("error", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <SendAgainLink onClick={handleResend} disabled={loading} label={label} />
  );
};

export default SendAgainFlow;
